import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@app/helpers/common.service';

@Component({
  selector: 'app-s-home',
  templateUrl: './s-home.component.html',
  styleUrls: ['./s-home.component.scss'],
})
export class SHomeComponent implements OnInit {
  providerInfo: any;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    try {
      this.commonService.onLoaderChange.next(true);
      this.providerInfo = await this.commonService.getHtmlTemplate({ route: 'service_home' });
      this.commonService.onLoaderChange.next(false);
    } catch (error) {
      console.error(error);
      this.commonService.onLoaderChange.next(false);
    }
  }
}
